export default __webpack_public_path__ + "static/media/complete.e117df85.svg";